import React, { useState, useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useSocketState } from '../../helpers/useSocket'
import PlayerPicker from '../../components/PlayerPicker'

function CastersDashboard() {
	const { socket } = useOutletContext()
	const [match] = useSocketState('Match')
	const [tournament] = useSocketState('Tournament')
	const [caster1Local, setCaster1Local] = useState({ name: '', country: '' })
	const [caster2Local, setCaster2Local] = useState({ name: '', country: '' })
	const [intervieweeLocal, setIntervieweeLocal] = useState({
		name: '',
		country: '',
	})

	useEffect(() => {
		if (match?.caster1) setCaster1Local(match.caster1)
	}, [match?.caster1])
	useEffect(() => {
		if (match?.caster2) setCaster2Local(match.caster2)
	}, [match?.caster2])
	useEffect(() => {
		if (match?.interviewee) setIntervieweeLocal(match.interviewee)
	}, [match?.interviewee])

	return (
		<div className="flex flex-row mt-4 gap-8 items-end">
			<div className="flex flex-col">
				<label>Caster 1</label>
				<PlayerPicker
					players={tournament?.config?.players}
					value={caster1Local.name}
					onChange={(name) =>
						setCaster1Local((prev) => ({ ...prev, name }))
					}
					countryValue={caster1Local.country?.toUpperCase()}
					countryOnChange={(country) =>
						setCaster1Local((prev) => ({ ...prev, country }))
					}
				/>
			</div>
			<div className="flex flex-col">
				<label>Caster 2</label>
				<PlayerPicker
					players={tournament?.config?.players}
					value={caster2Local.name}
					onChange={(name) =>
						setCaster2Local((prev) => ({ ...prev, name }))
					}
					countryValue={caster2Local.country?.toUpperCase()}
					countryOnChange={(country) =>
						setCaster2Local((prev) => ({ ...prev, country }))
					}
				/>
			</div>
			<div className="flex flex-col">
				<label>Interviewee</label>
				<PlayerPicker
					players={tournament?.config?.players}
					value={intervieweeLocal.name}
					onChange={(name) =>
						setIntervieweeLocal((prev) => ({ ...prev, name }))
					}
					countryValue={intervieweeLocal.country?.toUpperCase()}
					countryOnChange={(country) =>
						setIntervieweeLocal((prev) => ({ ...prev, country }))
					}
				/>
			</div>
			<button
				className="mb-10"
				onClick={() => {
					socket.emit('modifyCaster1', caster1Local)
					socket.emit('modifyCaster2', caster2Local)
					socket.emit('modifyInterviewee', intervieweeLocal)
				}}
			>
				Push to Live
			</button>
		</div>
	)
}

export default CastersDashboard
